<template>
	<div class="paddle-nav">
		<transition name="fade">
			<i class="paddle-nav-arrow paddle-nav-arrow-previous icon-leftArrow" 
			@click="previousIndex()" v-show="index>1"></i>
		</transition>
		<transition name="fade">
			<i class="paddle-nav-arrow paddle-nav-arrow-next icon-rightArrow" 
			@click="nextIndex()" v-show="index<length"></i>
		</transition>
		
	</div>
</template>
<script>
	export default {
		name: 'paddleNav',
		props: {
			length: {
				type: Number
			},
		},
		data() {
			return {
				index: 1
			}
		},
		methods: {
			previousIndex() {
				if (this.index !== 1) {
					this.index--;
					this.$emit('previousIndex')
				}
			},
			nextIndex() {

				if (this.index < this.length) {
					this.index++;
					this.$emit('nextIndex')
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	.paddle-nav { 
		width: calc(1040px + 50px); 
		left: calc(220px + (100% - 1260px)/2 - 25px);
		position: fixed; 
		height: 50px; 
		top: 50%;
		z-index: 1000;
		box-sizing: border-box; 
		pointer-events: none;
	}
	.paddle-nav-arrow { position: relative; width: 50px; height: 50px; border-radius: 50%; text-align: center; line-height: 50px; background: rgba(0, 0, 0, 0.1); color:#fff; z-index: 10; transition: all .25s; position: absolute; -webkit-user-select: none; pointer-events: auto;}
	.paddle-nav-arrow-previous { left: 0; }
	.paddle-nav-arrow-next { right: 0; }
	.hidden { display: none; }
	.paddle-nav-arrow:hover { background: #ff6000 }
</style>


// WEBPACK FOOTER //
// src/components/paddleNav/paddleNav.vue